import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'connected-react-router'
import { compose, withHandlers, withProps } from 'recompose'
import { showAppointmentUnsupportedModal } from 'components/Header/components/MakeAnAppointment/components/AppointmentUnsupportedModal/actions'
import { showStoreLocatorModal3StepperEnabled } from 'actions/storeLocator'
import Service from './Service'
import {
  getCurrentStore,
  getCurrentStorePhoneNumber,
  getCurrentStoreEnableAppointmentFlag
} from 'selectors/getCurrentStore'
import { get3StepperEnabled } from 'selectors/thirdPartyData'
import { QUICK_APPOINTMENT_PAGE } from 'constant'

const mapStateToProps = state => ({
  myStoreExists: Boolean(getCurrentStore(state)),
  myStorePhoneNumber: getCurrentStorePhoneNumber(state),
  myStoreAppointmentEnableFlag: getCurrentStoreEnableAppointmentFlag(state),
  threeStepperEnabled: get3StepperEnabled(state)
})

const withHandleNavigateToQuickAppointment = withHandlers({
  onClick: ({
    myStoreExists,
    myStorePhoneNumber,
    myStoreAppointmentEnableFlag,
    showAppointmentUnsupportedModal,
    threeStepperEnabled,
    showStoreLocatorModal3StepperEnabled,
    navigateToQuickApptPage,
    push,
    externalIdLong,
    history
  }) => e => {
    if (myStoreExists && !myStoreAppointmentEnableFlag) {
      e.preventDefault()
      showAppointmentUnsupportedModal({ phoneNumber: myStorePhoneNumber })
    } else if (!myStoreExists && threeStepperEnabled) {
      e.preventDefault()
      showStoreLocatorModal3StepperEnabled(externalIdLong)
    } else if (navigateToQuickApptPage) {
      history.push(`${QUICK_APPOINTMENT_PAGE}?preSelectedService=${externalIdLong}`)
    }
  }
})

export default compose(
  connect(mapStateToProps, { showAppointmentUnsupportedModal, showStoreLocatorModal3StepperEnabled, push }),
  withRouter,
  withProps(() => ({ navigateToQuickApptPage: true })),
  withHandleNavigateToQuickAppointment
)(Service)
